import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/nations/kwcn-crown.png")